
import * as React from 'react';
import {
  IItemsViewLayoutHandler,
  IItemsViewLayoutProps,
  itemsViewLayoutHandlerControl
} from '../../../controls/itemsViewBetaControl';
import { tilesLayoutType } from '../../layouts/TilesLayoutTypeFacet';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { asAsync } from '../../../utilities/components/Async';
import CommandStrings from '../../commands/Commands.resx';
import { withItemSetSelection } from '../../decorators/connectToSelection';
import { withPageLoadTracker } from '../../decorators/withPageLoadTracker';
import { withSelectedItemsContextMenu } from '../../decorators/withSelectedItemsContextMenu';

const AsyncTilesList = asAsync(async () => (
  await import(/* webpackChunkName: 'itemsettileslist' */'../../itemSetTilesList/ItemSetTilesList')
).ItemSetTilesList);

const ContextMenuTilesList = withSelectedItemsContextMenu()(AsyncTilesList);

const AsyncTilesListWithSelection = withItemSetSelection()(ContextMenuTilesList);

const PageLoadTilesList = withPageLoadTracker([])(AsyncTilesListWithSelection);

class LayoutTilesList extends React.PureComponent<IItemsViewLayoutProps> {
  public render(): JSX.Element {
    return (
      <PageLoadTilesList { ...this.props } />
    );
  }
}

export const itemsViewTilesLayoutHandler: IItemsViewLayoutHandler = {
  key: tilesLayoutType.id,
  command: {
    automationId: 'tilesListCommand',
    name: CommandStrings.ViewGrid,
    title: CommandStrings.ViewGridCommandTooltip,
    iconProps: {
      iconName: 'viewall'
    }
  },
  controlHandler: (
    itemCache: IItemCache,
    props: typeof itemsViewLayoutHandlerControl.inputType
  ): typeof itemsViewLayoutHandlerControl.returnType => {
    return {
      layout: LayoutTilesList
    };
  }
};
